import type { ReactNode } from 'react';
import { Navigate, useSearchParams } from 'react-router';
import { useMe } from '@/lib/auth';
import { safeNext } from './LoginPage';

/** Страницы входа/регистрации — только для гостей: вошедших сразу уводим дальше. */
export function GuestOnly({ children }: { children: ReactNode }) {
  const me = useMe();
  const [params] = useSearchParams();
  if (me.isLoading) return null;
  if (me.data?.user) return <Navigate to={safeNext(params.get('next'))} replace />;
  return <>{children}</>;
}
